import React, { useState, useEffect, useContext } from 'react';
import InvoicePreview from '../../components/secure/provider/invoices/invoice-preview/InvoicePreview';
import CloseAndWriteOff from '../../components/secure/provider/transactions/close-and-write-off/CloseAndWriteOff';
import ModalBox from '../../components/templates/components/ModalBox';
import { store } from '../../context/StateProvider';
import { RecurringOperation, RecurringPlanUtility } from './recurring-plan.utility';
import EditRecurringPlan from '../../components/secure/provider/transactions/terminals/installment-terminal/EditRecurringPlan';
import PaymentHistoryList from '../../components/secure/provider/report/paymentPlan-list/paymentPlan-card/payment-history-accordion/payment-history-list/PaymentHistoryList';
import { Button, Dropdown, Icon, Popup } from 'semantic-ui-react';
import PaymentsList from '../../components/secure/provider/report/paymentPlan-list/paymentPlan-card/payments-accordion/payments-list/PaymentsList';
import './ButtonGroup.scss'
import CancelInvoice from '../../components/secure/provider/transactions/cancel-invoice/CancelInvoice';
import PauseRestartPlan from '../../components/secure/provider/transactions/terminals/installment-terminal/PauseRestartPlan';

const RecurringPlanButtonGroup = (props) => {
  const state = useContext(store).state

  const [recurringPlan, setRecurringPlan] = useState(props.initialData || {})
  const [edit, setEdit] = useState(false);
  const [preview, setPreview] = useState(false);
  const [cancel, setCancel] = useState(false);
  const [confirmRestart, setConfirmRestart] = useState(false);
  const [restartPlan, setRestartPlan] = useState(false);
  const [confirmPause, setConfirmPause] = useState(false);
  const [cancelWO, setCancelWO] = useState(false);
  const [viewUpcomingPayments, setViewUpcomingPayments] = useState(false)
  const [viewPaymentHistory, setViewPaymentHistory] = useState(false)
  const [showStatusDescription, setShowStatusDescription] = useState(props.showStatusDescription === false ? false : true);
  const [showEdit, setShowEdit] = useState(props.showEdit === false ? false : true);
  const [showViewDetails, setShowViewDetails] = useState(props.showViewDetails === false ? false : true);
  const [showCancel, setShowCancel] = useState(props.showCancel === false ? false : true);
  const [showCancelAndWriteOff, setShowCancelAndWriteOff] = useState(props.showCancelAndWriteOff === false ? false : true);
  const [showPaymentHistory, setShowPaymentHistory] = useState(props.showPaymentHistory === false ? false : true);
  const [showUpcomingPayments, setShowUpcomingPayments] = useState(props.showUpcomingPayments === false ? false : true);
  const [buttonClass, setButtonClass] = useState(`${props.buttonClass ? props.buttonClass : ''} btn btn-primary`)
  const [dropdownItems, setDropdownItems] = useState([]);
  const [isDropDownOpen, setIsDropDownOpen] = useState(false);
  const [showPause, setShowPause] = useState(props.showPause === false ? false : true);
  const [showRestart, setShowRestart] = useState(props.showRestart === false ? false : true);
  // const ellipsisStyle = {
  //   display: 'flex',
  //   justifyContent: 'center',
  //   alignItems: 'center'
  // };
  useEffect(() => {
    const items = [];
    if (showPaymentHistory) {
      items.push(<Dropdown.Item key="view-payment-history" onClick={handleViewPaymentHistory}>View Payment History</Dropdown.Item>);
    }
    if (showUpcomingPayments) {
      items.push(<Dropdown.Item key="view-upcoming-payments" onClick={handleViewUpcomingPayments}>View Upcoming Payments</Dropdown.Item>);
    }
    if (showPause && RecurringPlanUtility.OperationAllowed(recurringPlan, RecurringOperation.PAUSE)) {
      items.push(<Dropdown.Item key="pause-payments" onClick={handlePausePayments}>Pause</Dropdown.Item>);
    }
    if (showRestart && RecurringPlanUtility.OperationAllowed(recurringPlan, RecurringOperation.RESTART)) {
      items.push(<Dropdown.Item key="restart-payments" onClick={handleRestartPayments}>Restart</Dropdown.Item>);
    }
    setDropdownItems(items);
  }, []);

  const handleViewPaymentHistory = () => {
    setViewPaymentHistory(true);
    setIsDropDownOpen(false);
  };
  const handleViewUpcomingPayments = () => {
    setViewUpcomingPayments(true);
    setIsDropDownOpen(false);
  };

  const handleEdit = () => {
    setEdit(true);
  };

  const handlePreview = () => {
    setPreview(true);
  };

  const handleCancel = () => {
    setCancel(true);
  };

  const handleCancelWO = () => {
    setCancelWO(true);
  };


  const handlePausePayments = () => {
    setConfirmPause(true);
    setIsDropDownOpen(false);
  };

  const handleRestartPayments = () => {
    setConfirmRestart(true);
    setIsDropDownOpen(false);
  };

  // const onSuccess = (message) => {
  //   if (props.refresh) {
  //     props.refresh()
  //   }
  //   if (props.onClose) {
  //     props.onClose()
  //   }
  //   if (props.exitHandler) {
  //     props.exitHandler()
  //   }
  // }
  return (
    <>
      {showStatusDescription && recurringPlan?.status && (
        <div className={`${props.buttonClass ? props.buttonClass : ''} pe-1 btn btn-secondary`} title={RecurringPlanUtility.GetStatusTitle(recurringPlan?.status)}>
          {RecurringPlanUtility.GetStatusTitle(recurringPlan?.status)}
        </div>
      )}
      {showEdit && RecurringPlanUtility.OperationAllowed(recurringPlan, RecurringOperation.UPDATE_PLAN) ? (
        <button className={buttonClass}
          title={"Update Payment Plan"}
          onClick={handleEdit}>
          <i className="icon pencil" />
        </button>
      ) : null}
      {showViewDetails && state.permissions.paymentsViewInvoices ? (
        <button className={buttonClass} title="Invoice Preview" onClick={handlePreview}>
          <i className="icon eye" />
        </button>
      ) : null}
      {showCancel && state.permissions.paymentsModifyInvoices && RecurringPlanUtility.OperationAllowed(recurringPlan, RecurringOperation.CANCEL) ? (
        <button className={buttonClass} title="Cancel" onClick={handleCancel}>
          <i className="icon close" />
        </button>
      ) : null}

      {showCancelAndWriteOff && state.permissions.paymentsModifyInvoices && RecurringPlanUtility.OperationAllowed(recurringPlan, RecurringOperation.CANCEL_WRITE_OFF) ? (
        <button className={buttonClass} title="Cancel & Write Off" onClick={handleCancelWO}>
          <i className="icon close" />
        </button>
      ) : null}
      {/* pass extra button extraButton={extraButtons} */}
      {props.extraButton && props.extraButton}
      {dropdownItems.length > 0 && (
        <Popup
          className="no-border-popup"
          trigger={
            <Button
              icon
              className={`${props.buttonClass ? 'btn-primary p-1 m-0' : 'btn-primary'} `}
              style={{ cursor: 'pointer',borderRadius: '0px 5px 5px 0'}}
            >
              <Icon name="ellipsis horizontal"/>
            </Button>
          }
          content={
            <Dropdown.Menu className="custom-popup-menu" closePopup={() => setIsDropDownOpen(false)}>
              {dropdownItems}
            </Dropdown.Menu>
          }
          on="click"
          position="top right"
          open={isDropDownOpen}
          onClose={() => setIsDropDownOpen(false)}
          onOpen={() => setIsDropDownOpen(true)}
        />
      )}
      {/* {dropdownItems.length > 0 && (
        <Dropdown button direction="left" icon="ellipsis horizontal" className={`${props.buttonClass ? 'btn-primary icon btn p-1 ps-0 m-0' : 'btn-primary icon btn p-o'}`} style={ellipsisStyle}>
          <Dropdown.Menu>
            {dropdownItems}
          </Dropdown.Menu>
        </Dropdown>
      )} */}

      {preview && (
        <ModalBox open={preview} onClose={() => { setPreview(false) }} title={`Invoice Preview`} size="fullscreen">
          <InvoicePreview invoiceId={recurringPlan?.invoiceId} isModal onClose={() => { setPreview(false) }} />
        </ModalBox>
      )}

      {(edit || restartPlan) && (
        <ModalBox open={edit || restartPlan}
          onClose={() => {
            setEdit(false);
            setRestartPlan(false);
          }}
          title={restartPlan ? "Restart Plan" : "Update Installment Plan"}>
          <EditRecurringPlan
            transactionType={recurringPlan?.transactionType}
            initialData={recurringPlan}
            submitLabel={restartPlan ? "Restart" : "Update"}
            onClose={() => {
              setEdit(false);
              setRestartPlan(false);
            }}
            refresh={() => { if(props.refresh) props.refresh() }}
            isModal
          />
        </ModalBox>
      )}

      {cancel && (
        <ModalBox open={cancel} onClose={() => { setCancel(false) }} size="tiny" title="Cancel Invoice">
          <CancelInvoice refresh={() => { props.refresh() }} invoiceId={recurringPlan?.invoiceId} onClose={() => { setCancel(false) }} />
        </ModalBox>
      )}

      {cancelWO && (
        <ModalBox open={cancelWO} onClose={() => { setCancelWO(false) }} size="tiny" title="Close and Write Off">
          <CloseAndWriteOff refresh={() => { props.refresh() }} invoiceId={recurringPlan?.invoiceId} onClose={() => { setCancelWO(false) }} />
        </ModalBox>
      )}

      {viewPaymentHistory && (
        <ModalBox open={viewPaymentHistory} onClose={() => { setViewPaymentHistory(false) }} title="Payment History">
          <PaymentHistoryList paymentPlan={recurringPlan} pull={true}/>
        </ModalBox>
      )}

      {viewUpcomingPayments && (
        <ModalBox open={viewUpcomingPayments} onClose={() => { setViewUpcomingPayments(false) }} title="Scheduled Payments">
          <PaymentsList paymentPlanId={recurringPlan?.id} pull={true}/>
        </ModalBox>
      )}

      {confirmPause && (
        <ModalBox open={confirmPause} onClose={() => { setConfirmPause(false) }} size="tiny" title="Pause Plan">
          <PauseRestartPlan refresh={() => { if (props.refresh) props.refresh() }} initialData={recurringPlan} onClose={() => { setConfirmPause(false) }} />
        </ModalBox>
      )}
      {confirmRestart && (
        <ModalBox open={confirmRestart} onClose={() => { setConfirmRestart(false) }} size="tiny" title="Restart Plan">
          <PauseRestartPlan
            isPaused={true}
            refresh={() => { if (props.refresh) props.refresh() }}
            initialData={recurringPlan}
            onClose={() => { setConfirmRestart(false) }}
            onRestart={() => {
              setConfirmRestart(false)
              setRestartPlan(true);
            }}
          />
        </ModalBox>
      )}
    </>
  );
};

export default RecurringPlanButtonGroup;